











































































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { MedicalSpecification } from "@/components/medicalTransmissionEdit/types";
import EditDayChangePicker from "@/components/common/EditDayChangePicker.vue";
import NumberInput from "@/components/common/NumberInput.vue";

@Component({
  components: { EditDayChangePicker, NumberInput }
})
export default class OtherMedical3 extends Vue {
  @Prop() tab!: MedicalSpecification;
  private addEmergencyReason() {
    this.tab.emergency_reasons.push({
      id: 0,
      medical_specification_id: this.tab.id,
      office_id: this.tab.office_id,
      date_str: "",
      text: "",
      created_at: null,
      updated_at: null,
      deleted_at: null
    });
    return;
  }
  private delEmergencyReason(idx: number) {
    this.tab.emergency_reasons.splice(idx, 1);
    return;
  }
}
